<select class="form-control" [ngClass]="{'input-sm': smallSize}"
        [(ngModel)]="selectedLanguage" [disabled]="disabled"
        (ngModelChange)="onChangeCb($event)">
  <option value="" *ngIf="!disableEmptyValue"></option>
  <option *ngFor="let opt of languageOptions | keyvalue" [ngValue]="opt.key">{{opt.value}}</option>
</select>
